/**
 * One stable per-slot colour palette, used EVERYWHERE a product slot is shown in
 * the Layout Designer — the layers-tab chip, the in-editor preview badge/ring, and
 * the source-board highlight. "Same colour = same product" then reads at a glance,
 * and an accidental key-split (two elements that should share a product but don't)
 * shows up as an unexpected extra colour.
 *
 * Slot numbers are 1-based (see `getLayoutProductSlots`). Hues are picked to stay
 * distinguishable on the dark designer canvas AND as translucent chip fills.
 */
const SLOT_HUES = [
  "#4F9DFF", // blue
  "#FFB020", // amber
  "#34D399", // green
  "#F472B6", // pink
  "#A78BFA", // violet
  "#F87171", // red
  "#22D3EE", // cyan
  "#FB923C", // orange
  "#C0CA33", // lime
  "#E879F9", // magenta
];

const NEUTRAL = "#9AA0A6";

/** Solid hue for a 1-based slot number; cycles for layouts with many slots. */
export const slotColor = (slot?: number): string => {
  if (!slot || slot < 1) return NEUTRAL;
  return SLOT_HUES[(slot - 1) % SLOT_HUES.length];
};
